const ACTIONS_PERMISSION = {
  contagem: <const>[
    'read',
    'manage',
    'canChangeDensity',
    'canChangeProductivity',
  ],
  ocorrencia: <const>['read', 'manage'],
  recomendacao: <const>['read', 'manage'],
  anotacao: <const>['read', 'manage'],
  estoque: <const>['read', 'canViewStock', 'canTransferStock'],
  clima: <const>['read', 'manage', 'integracaoPluviometros'],
  demarcacaoArea: <const>['read', 'manage'],
  pulverizacao: <const>['read', 'manage', 'readAppHistoric', 'editDelete'],
  registroDeSemeadura: <const>['read', 'manage'],
  correcaoSolo: <const>['read', 'manage', 'editDelete'],
  adubacao: <const>['read', 'manage', 'editDelete'],
  usosMaquinas: <const>['read', 'manage'],
  ocorrenciaComMaquinas: <const>['manage', 'read', 'canValidateCheck'],
  mapas: <const>['manage'],
  recomendacaoSemeadura: <const>['read', 'manage', 'editDelete'],
  tarefa: <const>['read', 'manage', 'createFromApp'],
  mapasDeCalor: <const>['read', 'manage'],
  parameters: <const>['manage'],
  roles: <const>['read', 'manage'],
  users: <const>[
    'manage',
    'canAproveRecommendation',
    'canRecommendWithoutApproval',
    'canAuditPulverization',
    'canPulverizeWithoutAudit',
    'canViewAudits',
    'canReplaceProducts',
  ],
  depositos: <const>['manage', 'read'],
  glebas: <const>['manage', 'read'],
  safras: <const>['manage', 'read'],
  tratamentoSemente: <const>['manage', 'read'],
  estadiosFenologicos: <const>['manage', 'read'],
  propriedades: <const>['manage', 'read'],
  visitsPanel: <const>['read', 'readTracking'],
  usersPanel: <const>['read'],
  visitsReport: <const>['read'],
  timeline: <const>['read'],
  dashboard: <const>['read'],
  colheitas: <const>['manage', 'read'],
  produtividade: <const>['read'],
  tiposOcorrencia: <const>['read', 'manage'],
  itensEstoque: <const>['read', 'manage'],
  colheitaAfericao: <const>['read', 'manage'],
  semeaduraAfericao: <const>['read', 'manage'],
  contratos: <const>['manage'],
  operacao: <const>['read', 'manage'],
  atividade: <const>['read', 'manage'],
  maquina: <const>['read', 'manage'],
  plantio: <const>['read', 'manage'],
  pluviometro: <const>['read', 'manage'],
  aplicacaoAfericao: <const>['read', 'manage'],
};

export default ACTIONS_PERMISSION;
